import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Divider from '@material-ui/core/Divider'
import DialogTitle from '@material-ui/core/DialogTitle'
import ContactInfoForm from '../../../ContactInfo/Form'
import { StyledActions, StyledContent } from '../styles'
import { useOnboarding } from '../../../../../contexts/OnboardingContext'
import { Box, DialogContentText } from '@material-ui/core'

export default function ContactInfoDialog(props) {
  const { open, handleClose, data, setPropChange } = props
  const { formRef } = useOnboarding()

  const updateForm = async () => {
    await formRef.current.handleSubmit()

    setPropChange(true)
    handleClose()
  }
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm">
      <DialogTitle>Contact Info</DialogTitle>
      <DialogContentText>We are first going to get to know you a little better.</DialogContentText>
      <StyledContent>
        <ContactInfoForm initialValues={data} />
      </StyledContent>
      <Box my={2}>
        <Divider />
      </Box>
      <StyledActions>
        <Button variant="outlined" onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button variant="contained" onClick={updateForm} color="default">
          Save
        </Button>
      </StyledActions>
    </Dialog>
  )
}
